import React, { useState } from "react";
import "./ConsultantForm.css";

const API_BASE = "https://overseas-backend-1-548y.onrender.com";

function ConsultantForm({ onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    level: "",
  });

  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // ✅ clear old messages while typing
    if (status.success || status.error) {
      setStatus({ loading: false, success: false, error: null });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: null });

    try {
      const response = await fetch(`${API_BASE}/api/consultation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      // ✅ safely parse json
      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(result.message || "Failed to submit consultation request");
      }

      setStatus({ loading: false, success: true, error: null });
      setFormData({
        name: "",
        email: "",
        phone: "",
        country: "",
        level: "",
      });

      // ✅ optional: auto close after success
      // setTimeout(() => onClose?.(), 1200);
    } catch (error) {
      console.error("Error submitting consultation form:", error);
      setStatus({
        loading: false,
        success: false,
        error: error?.message || "Something went wrong",
      });
    }
  };

  return (
    <div className="consultant-overlay" onClick={onClose}>
      <div className="consultant-container" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="consultant-close-btn" type="button">
          &times;
        </button>

        <h2 className="consultant-title">Get a Free Consultation</h2>

        <form className="consultant-form" onSubmit={handleSubmit}>
          <div>
            <label className="consultant-label">Name</label>
            <input
              type="text"
              name="name"
              className="consultant-input"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label className="consultant-label">Email</label>
            <input
              type="email"
              name="email"
              className="consultant-input"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label className="consultant-label">Phone Number</label>
            <input
              type="tel"
              name="phone"
              className="consultant-input"
              placeholder="Your Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label className="consultant-label">Destination Country</label>
            <select
              name="country"
              className="consultant-input"
              value={formData.country}
              onChange={handleChange}
              required
            >
              <option value="">Select Country</option>
              <option value="USA">USA</option>
              <option value="Canada">Canada</option>
              <option value="Australia">Australia</option>
              <option value="UK">UK</option>
              <option value="Germany">Germany</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Ireland">Ireland</option>
              <option value="Others">Others</option>
            </select>
          </div>

          <div>
            <label className="consultant-label">Level of Study</label>
            <select
              name="level"
              className="consultant-input"
              value={formData.level}
              onChange={handleChange}
              required
            >
              <option value="">Select Level</option>
              <option value="Undergraduate">Undergraduate</option>
              <option value="Postgraduate">Postgraduate</option>
              <option value="PhD">PhD</option>
              <option value="Diploma">Diploma</option>
              <option value="Others">Others</option>
            </select>
          </div>

          <button type="submit" className="consultant-submit" disabled={status.loading}>
            {status.loading ? "Submitting..." : "Submit"}
          </button>

          {status.success && <p className="success-msg">✅ Request submitted successfully!</p>}
          {status.error && <p className="error-msg">❌ {status.error}</p>}
        </form>
      </div>
    </div>
  );
}

export default ConsultantForm;
